<template>
    <b-notification
        v-if="show"
        :type="type"
        :closable="false"
        v-html="message"
    />
</template>

<script>
export default {
    computed: {
        show: function() {
            return (this.$route.query.success || this.$route.query.error);
        },
        type: function() {
            const { query } = this.$route;

            return (query.valid === '0' || query.success === '0' || query.error === '1' ? 'is-danger' : 'is-warning');
        },
        message: function() {
            const { query } = this.$route;

            if (query.error === '1') {
                return 'There was an issue taking your payment. Please try again.';
            } else if (query.valid === '0') {
                return 'There was an issue processing your payment. The payment gateway returned an invalid response.';
            } else if (query.success === '0') {
                return 'There was an issue processing your payment.';
            } else {
                return 'Thanks for your payment.';
            }
        },
    },
};
</script>
